var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18C11.7667 18 10.6127 17.7707 9.538 17.312C8.46267 16.854 7.51667 16.225 6.7 15.425L8.125 14C8.75833 14.6167 9.49167 15.104 10.325 15.462C11.1583 15.8207 12.05 16 13 16C14.9333 16 16.5833 15.3167 17.95 13.95C19.3167 12.5833 20 10.9333 20 9C20 7.06667 19.3167 5.41667 17.95 4.05C16.5833 2.68333 14.9333 2 13 2C11.0667 2 9.41667 2.68333 8.05 4.05C6.68333 5.41667 6 7.06667 6 9V9.175L7.825 7.35L9.25 8.75L5 13L0.75 8.75L2.175 7.35L4 9.2V9C4 7.75 4.23767 6.579 4.713 5.487C5.18767 4.39567 5.82933 3.44567 6.638 2.637C7.446 1.829 8.396 1.18733 9.488 0.712C10.5793 0.237333 11.75 0 13 0C14.25 0 15.421 0.237333 16.513 0.712C17.6043 1.18733 18.5543 1.829 19.363 2.637C20.171 3.44567 20.8127 4.39567 21.288 5.487C21.7627 6.579 22 7.75 22 9C22 11.5 21.125 13.625 19.375 15.375C17.625 17.125 15.5 18 13 18Z",
    fill: "#219F53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.c866e9be.svg";
export { ForwardRef as ReactComponent };